import { getSubmit } from '@ui-seeker/utils'
import { BACKEND_APIS } from '@constants'
import { passDecisions } from 'Pages/AnalyzersV2/@signals'

import { decisionsQuery } from 'Pages/AnalyzersV2/@services/passView'
import { createLatestGate, shouldPaint } from '@components/KindPillsField/latestOnly'

// two cars picked in a row: only the decisions of the last one paint (CU-869fmpqfm, UX Obs. 5)
const gate = createLatestGate()

/** After a search with a pass open: the engine's decisions of that office, narrowed like the table (CU-869fmm949). */
export function loadPassDecisions(payload) {
	if (!payload?.repricingExecutionID || !payload?.officePickupID) {
		gate.next()
		passDecisions.value = null
		return
	}
	const id = gate.next()
	passDecisions.value = { loading: true }
	getSubmit(`${BACKEND_APIS.GENERAL_REPRICING_API}/analyzer/decisions`, decisionsQuery(payload))
		.then(res => { if (shouldPaint(gate, id)) passDecisions.value = res || { cells: [] } })
		.catch(err => { if (shouldPaint(gate, id, err)) passDecisions.value = { error: true, cells: [] } })
}
